import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ff95978"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "relative"
}
const _hoisted_2 = {
  key: 0,
  src: "https://images.rubin-trauringe.de/assets/position-hand1-bg.webp",
  class: "w-full z-10 absolute inset-0"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  class: "relative top-0 left-0"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-end justify-center h-64 pt-4 px-4 pb-20 text-center sm:block sm:p-0\" data-v-4ff95978><div class=\"inset-0 bg-gray-100 bg-opacity-75 transition-opacity\" aria-hidden=\"true\" data-v-4ff95978></div><span class=\"hidden sm:inline-block sm:align-middle\" aria-hidden=\"true\" data-v-4ff95978>​</span><div class=\"inline-block align-middle overflow-hidden object-center transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6\" data-v-4ff95978><div class=\"lds-ripple border-brand-main\" data-v-4ff95978><div class=\"border-brand-main\" data-v-4ff95978></div><div class=\"border-brand-main\" data-v-4ff95978></div></div></div></div>", 1)
const _hoisted_7 = [
  _hoisted_6
]

import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'confItemImage',
  props: ["imageUrl", "imageLayerUrl"],
  setup(__props) {

const props = __props;



const finaleImageUrl = ref("");
const finaleImageLayerUrl = ref("");

const retryCounter = ref(0);
const retryCounterLayer = ref(0);
const maxRetries = 10;

/**
 * Das Bild wird so lange neu geladen, bis es vom Server komplett generiert wurde.
 * @param imageUrl
 */
const loadImage = (imageUrl: string) => {
  console.debug("Try to load", imageUrl);
  retryCounter.value += 1;
  const img = new Image();
  img.src = imageUrl;

  img.onload = () => {
    finaleImageUrl.value = imageUrl;
    retryCounter.value = 0;
  };
  img.onerror = () => {
    if (retryCounter.value <= maxRetries) {
      setTimeout(loadImage, 500, imageUrl);
    }
  };
  //
};

loadImage(props.imageUrl);

const loadLayerImage = (imageLayerUrl: string) => {
  //console.log(imageLayerUrl);
  if (imageLayerUrl != "" && typeof imageLayerUrl != "undefined") {
    // console.debug("Try to load", imageLayerUrl);
    retryCounterLayer.value += 1;
    const img = new Image();
    img.src = imageLayerUrl;

    img.onload = () => {
      finaleImageLayerUrl.value = imageLayerUrl;
    };
    img.onerror = () => {
      if (retryCounterLayer.value <= maxRetries) {
        setTimeout(loadImage, 500, imageLayerUrl);
      }
    };
  }
};

loadLayerImage(props.imageLayerUrl);

/**
 * Watcher überwacht, ob sich das Bild verändert hat und startet den Lade-Prozess erneut
 */
watch(
  () => props.imageUrl,
  (imageUrl: string) => {
    loadImage(imageUrl);
  },
  { deep: true }
);

watch(
  () => props.imageLayerUrl,
  (imageUrl: string) => {
    loadLayerImage(imageUrl);
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (retryCounter.value > maxRetries && !__props.imageUrl.includes('hand1-'))
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createTextVNode(" Error - unable to load image ")
      ], 64))
    : (finaleImageUrl.value != '' || __props.imageUrl.includes('hand1-'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (__props.imageUrl.includes('hand1-'))
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("img", {
            src: finaleImageUrl.value,
            class: "w-full z-10 relative"
          }, null, 8, _hoisted_3),
          (finaleImageLayerUrl.value != '')
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: finaleImageLayerUrl.value,
                class: "absolute w-full inset-0 z-30"
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
}
}

})